export enum ProfitabilityChangeGroup {
  PROFIT = 'profit',
  LOSS = 'loss',
  COST = 'cost',
  TOTAL_REVENUE = 'totalRevenue',
}

export enum ProfitabilityCumulativeChangeGroup {
  CUMULATIVE_PROFIT = 'cumulativeProfit',
  POSITIVE_PROFIT = 'positiveProfit',
  NEGATIVE_PROFIT = 'negativeProfit',
  RETAINED_PROFIT = 'retainedProfit',
}
